// extracted by mini-css-extract-plugin
module.exports = {"Popup":"Popup_Popup__1OL6P","PopupBack":"Popup_PopupBack__IREZE","Header":"Popup_Header__3docr","show":"Popup_show__20K88","Content":"Popup_Content__2MSeg"};